import { TagType, type TagTypeType } from 'Common/SearchBar/types';

export const QUERY_PARAM_SEARCH = 'q';
export const QUERY_PARAM_INCLUDE_TAGS = 'includeTags';
export const QUERY_PARAM_EXCLUDE_TAGS = 'excludeTags';

export const encodeTagArray = (tags: string[]): string => {
  if (tags.length === 0) {
    return '';
  }

  return tags.map(tag => encodeURIComponent(tag)).join(',');
};

export const decodeTagArray = (encoded: string | null): string[] => {
  if (!encoded || encoded.trim() === '') {
    return [];
  }

  return encoded
    .split(',')
    .map(tag => {
      try {
        return decodeURIComponent(tag.trim());
      } catch {
        return tag.trim();
      }
    })
    .filter(tag => tag !== '');
};

export const buildSelectedTags = (
  includeTags: string[],
  excludeTags: string[]
): Array<{ name: string; type: TagTypeType }> => {
  const selectedTags: Array<{ name: string; type: TagTypeType }> = [];

  for (const tag of includeTags) {
    selectedTags.push({ name: tag, type: TagType.Include });
  }

  for (const tag of excludeTags) {
    selectedTags.push({ name: tag, type: TagType.Exclude });
  }

  return selectedTags;
};

export const createSearchParamsHash = (
  searchText: string,
  includeTags: string[],
  excludeTags: string[]
): string =>
  JSON.stringify({
    searchText: searchText ?? '',
    includeTags: includeTags ?? [],
    excludeTags: excludeTags ?? []
  });
